import { getTeamPageUrl } from "../../../../utils/urls"
import Link from "next/link"
import { LocalizedTeam } from "../../../../types/team"
import * as ImageConstants from "../../../../constants/images"
import Image from "next/image"
import { Row, Col } from "react-bootstrap"
import style from "./style.module.scss"
import cx from "classnames"
import { useState } from "react"
import { Button } from "@components/UI/Button"

export function CompetitionTeams({
  competitionCalciocomSlug,
  seasonCalciocomSlug,
  teams,
}: {
  competitionCalciocomSlug: string
  seasonCalciocomSlug: string
  teams: LocalizedTeam[]
}) {
  const [showAll, setShowAll] = useState(false)
  const initialTeamCount = 20

  const displayedTeams = showAll ? teams : teams.slice(0, initialTeamCount)

  const handleShowAll = () => {
    setShowAll(true)
  }

  return (
    <div className={style.competitionTeamsContainer}>
      <Row className={style.competitionTeamsRowPlaceholder}>
        <Col className={style.teamNamePlaceholder}>
          <span>Squadra</span>
        </Col>
        <Col className={style.teamImgPlaceholder}>
          <span>Badge</span>
        </Col>
      </Row>
      {displayedTeams.map((team, index) => {
        const isOdd = (index + 1) % 2 === 1
        const teamUrl = getTeamPageUrl(team.calciocomSlug!, competitionCalciocomSlug, seasonCalciocomSlug)
        return (
          <Row key={index} className={cx(style.competitionTeamsRow, isOdd ? style.odd : null)}>
            <Col className={style.teamName}>
              <Link href={teamUrl}>
                <a title={team.name}>{team.name}</a>
              </Link>
            </Col>
            <Col className={style.teamImg}>
              <Link href={teamUrl}>
                <a title={team.name} className={style.img}>
                  <Image
                    src={team.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
                    alt={team.name}
                    title={team.name}
                    layout={"intrinsic"}
                    width={24}
                    height={24}
                    className="new-team-image"
                  />
                </a>
              </Link>
            </Col>
          </Row>
        )
      })}
      {teams.length > initialTeamCount && !showAll && (
        <div className={style.showAllButtonContainer}>
          <Button text="Vedi tutto" className={style.btn} onClick={handleShowAll} />
        </div>
      )}
    </div>
  )
}
